import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/MalindiPhase9";

const MalindiPhase9 = () => {
  const projectId = "PRJ00089";
  const title = "Malindi Phase 9";

  const mapConfig = {
    minZoom: 12,
    zoom: 13,
    bounds: [
      [40.72, -74.147],
      [40.61, -73.90],
    ],
    // No overlays active in original file
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/plots-in-ngong/achievers-paradise-ngong-kimuka-phase2/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSeq-h_ydPVfvofXJj1FNvHBRtB_f7soDmVfM2Bvquy4H7L6VA/viewform"
    />
  );
};

export default MalindiPhase9;
